import { styled, theme } from "@theme/stitches.config"
import { Link } from "gatsby"
import { Container } from "@components/styles"

export const NavBarContainer = styled("div", {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 15
})

export const NavBarWrapper = styled("header", {
    backgroundColor: theme.colors.Y500,
    height: 100,
    ul: {
        listStyle: "none"
    },
    "@mdDown": {
        height: 70
    }
})

export const InnerWrapper = styled(Container, {
    position: "relative",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@lgDown": {
        justifyContent: "space-between"
    }
})

export const LogoWrapper = styled("a", {
    cursor: "pointer",
    position: "relative",
    top: 53,
    "@lgDown": {
        top: 0
    },
    "& img, & .gatsby-image-wrapper, * .gatsby-image-wrapper img": {
        width: 150,
        minWidth: 150,
        height: "auto",
        "@xlDown": {
            width: 100,
            minWidth: 100,
            height: "auto"
        },
        "@lgDown": {
            width: 80,
            minWidth: 80,
            height: "auto"
        },
        "@mdDown": {
            width: 50,
            minWidth: 50,
            height: "auto"
        }
    }
})

export const Submenu = styled("ul", {
    display: "block",
    opacity: 0,
    pointerEvents: "none",
    transform: "translateY(-20px)",
    transition: "transform 0.2s ease-out, opacity 0.3s ease",
    p: 20,
    position: "absolute",
    top: "100%",
    left: 0,
    minWidth: 250,
    backgroundColor: theme.colors.Y500,
    "& a": {
        p: 0
    }
})

export const LinkWrapper = styled("ul", {
    p: 0,
    m: 0,
    listStyle: "none",
    height: "100%",
    display: "flex",
    flexGrow: 1,
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    "@lgDown": {
        display: "none"
    },
    "& > li": {
        position: "relative"
    },
    [`& > li:hover > ${Submenu}`]: {
        opacity: 1,
        pointerEvents: "all",
        transform: "translateY(0px)"
    }
})

export const StyledLink = styled(Link, {
    position: "relative",
    textTransform: "uppercase",
    cursor: "pointer",
    px: 20,
    color: theme.colors.black,
    fontSizePxToRem: 24,
    lineHeight: 1.2,
    fontFamily: theme.fonts.heading,
    "@xlDown": {
        fontSizePxToRem: 20
    },
    "@mdDown": {
        display: "block"
    }
})

export const ButtonWrapper = styled("div", {
    "& button": {
        padding: "5px 20px"
    },
    "@lgDown": {
        display: "none"
    }
})

export const Hamburger = styled("div", {
    width: 48,
    height: 48,
    borderRadius: 9999,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    position: "relative",
    "& span": {
        position: "absolute",
        display: "block",
        background: theme.colors.R600,
        height: 2,
        left: 8,
        right: 8,
        borderRadius: 1,
        transition: "none",
        "&::before, &::after": {
            content: "",
            position: "absolute",
            display: "block",
            backgroundColor: theme.colors.R600,
            height: 2,
            width: 32,
            borderRadius: 1,
            transition: "transform 200ms ease"
        },
        "&::before": {
            top: -10
        },
        "&::after": {
            top: 10
        }
    },
    "@lgUp": {
        display: "none"
    },
    variants: {
        isMenuOpen: {
            true: {
                "& span": {
                    backgroundColor: "transparent",
                    "&::before, &::after": {
                        top: 0
                    },
                    "&::before": {
                        transform: "rotate(45deg)"
                    },
                    "&::after": {
                        transform: "rotate(-45deg)"
                    }
                }
            }
        }
    }
})

export const MobileMenu = styled("div", {
    opacity: 0,
    pointerEvents: "none",
    transform: "translate3d(0, -100%, 0)",
    zIndex: 1040,
    position: "fixed",
    top: 70,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.colors.Y500,
    transition: "all 200ms ease",
    pt: 60,
    pb: 55,
    px: 20,
    fontWeight: theme.fontWeights.bold,
    fontSizePxToRem: 34,
    backfaceVisibility: "hidden",
    overflowY: "auto",
    height: "calc(100vh - 70px)",
    "@mdUp": {
        top: 100,
        height: "calc(100vh - 100px)"
    },
    "@lgUp": {
        display: "none"
    },
    variants: {
        show: {
            true: {
                opacity: 1,
                pointerEvents: "all",
                transform: "translate3d(0, 0%, 0)",
                "@mdDown": {
                    top: 70,
                    height: "100%"
                }
            }
        }
    }
})

export const MobileLinkWrapper = styled("ul", {
    display: "block",
    m: "40px 0",
    p: "0 15px",
    listStyle: "none",
    li: {
        my: 20
    },
    "& ul": {
        li: {
            my: 0
        }
    }
})

export const StyledMobileLink = styled(StyledLink, {
    fontSizePxToRem: 20,
    px: 10
})

export const MobileButtonWrapper = styled(ButtonWrapper, {
    mt: 20,
    "@lgDown": {
        display: "block"
    }
})

export const MobileSubmenu = styled("ul", ({
    display: "block",
    listStyle: "none",
    m: 0,
    ml: 20,
    p: 0
}))
